import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatetimeRangePickerComponent } from './datetime-range-picker/datetime-range-picker.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LdmCoreModule } from '../../../core/core.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { CustomRangeHeaderComponent } from './custom-range-header/custom-range-header.component';
import { CustomRangePanelComponent } from './custom-range-header/custom-range-panel/custom-range-panel.component';
import { LdmDateAdapter } from './ldm.date.adapter';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

@NgModule({
  declarations: [DatetimeRangePickerComponent, CustomRangeHeaderComponent, CustomRangePanelComponent],
  imports: [
    CommonModule, 
    NgbModule, 
    FormsModule, 
    LdmCoreModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    NgxDaterangepickerMd.forRoot()
  ],

  exports: [DatetimeRangePickerComponent, CustomRangeHeaderComponent, CustomRangePanelComponent],
  providers: [{provide: DateAdapter, useClass: LdmDateAdapter }]
})
export class DatetimeRangePickerModule {}
